export const SETUP_AREAS = ['security', 'services', 'messaging', 'maps', 'payments', 'analytics', 'operation'];
export const SETUP_ITEM_IDS = [
    'credential_vault',
    'operator_mfa',
    'events_alive',
    'worker_alive',
    'email',
    'email_domain',
    'otp_whatsapp',
    'otp_sms',
    'otp_webhook',
    'otp_test_code',
    'otp_country',
    'push',
    'geo_providers',
    'geo_cascade',
    'map_tiles',
    'wallet_top_up',
    'online_payments',
    'analytics_reader',
    'analytics_pseudonym',
    'markets',
    'country_pack',
    'kyc_catalog',
    'country_policies',
    'market_status',
    'market_tariffs',
    'market_service_area',
    'market_policies',
    // D615 follow-up: informative, after the D616 items so parallel fronts touch different lines.
    'market_catalog',
    'central_teams',
    'widget_market',
    // D854: the rides, Food and alert settings a launched city needs (informative: a warning, not a block).
    'market_ride_policies',
    'market_food_policies',
    'market_alerts',
];
export const SETUP_ITEM_STATES = ['ok', 'missing', 'incomplete', 'disabled', 'invalid', 'attention', 'not_built', 'unknown'];
export const SETUP_LEVELS = ['platform', 'country', 'market'];
export const SETUP_REASON_CODES = [
    'SETUP_OK',
    'SETUP_VAULT_KEY_MISSING',
    'SETUP_OPERATORS_WITHOUT_MFA',
    'SETUP_OPERATORS_SHARED_MFA',
    'SETUP_SERVICE_SILENT',
    'SETUP_SERVICE_NEVER_SEEN',
    'SETUP_SLOT_EMPTY',
    'SETUP_SLOT_KEY_MISSING',
    'SETUP_SLOT_CONFIG_INCOMPLETE',
    'SETUP_SLOT_DISABLED',
    'SETUP_SLOT_INVALID',
    'SETUP_OTP_NOT_LIVE',
    'SETUP_OTP_TEST_FAILED',
    'SETUP_EMAIL_NO_SENDER',
    'SETUP_EMAIL_SPF_MISSING',
    'SETUP_EMAIL_DKIM_MISSING',
    'SETUP_EMAIL_DNS_UNREACHABLE',
    'SETUP_EMAIL_DOMAIN_UNCHECKED',
    'SETUP_WEBHOOK_SECRETS_MISSING',
    'SETUP_OTP_COUNTRY_NOT_GOVERNED',
    'SETUP_POLICY_UNVERIFIED',
    'SETUP_OTP_TEST_CODE_ON',
    'SETUP_NOT_BUILT',
    'SETUP_GEO_NO_VENDOR',
    'SETUP_GEO_CASCADE_UNSET',
    'SETUP_GEO_CASCADE_INVALID',
    'SETUP_GEO_SANDBOX_ONLY',
    'SETUP_GEO_PROVIDERS_UNCONFIGURED',
    'SETUP_WALLET_NO_ADAPTER',
    'SETUP_WALLET_ENVIRONMENT_UNSET',
    'SETUP_ENV_MISSING',
    'SETUP_KEY_TOO_SHORT',
    'SETUP_NO_MARKETS',
    'SETUP_NO_SELLING_MARKET',
    'SETUP_PACK_NOT_APPROVED',
    'SETUP_KYC_CATALOG_MISSING',
    'SETUP_MARKET_NOT_LAUNCHED',
    'SETUP_MARKET_STOPPED',
    'SETUP_NO_CATEGORIES',
    'SETUP_CATEGORIES_WITHOUT_FARE',
    'SETUP_SERVICE_AREA_UNPUBLISHED',
    'SETUP_SERVICE_AREA_PROVISIONAL',
    'SETUP_POLICIES_NOT_SET',
    'SETUP_CATALOG_NOT_GOVERNED',
    'SETUP_CENTRAL_TEAM_EMPTY',
    'SETUP_WIDGET_WITHOUT_MARKET',
    'SETUP_GEO_PROVIDER_FAILING',
    'SETUP_RIDE_POLICIES_NOT_SET',
    'SETUP_FOOD_POLICIES_NOT_SET',
    'SETUP_ALERTS_THRESHOLDS_UNSET',
];
export class SetupReadinessApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The checklist for one market (`market`), one country (`country`) or the whole platform (neither). */
    get(market, country) {
        const params = new URLSearchParams();
        if (market !== undefined && market !== '')
            params.set('market', market);
        else if (country !== undefined && country !== '')
            params.set('country', country);
        const qs = params.toString();
        return this.client.request({ method: 'GET', path: `/v1/admin/setup-readiness${qs !== '' ? `?${qs}` : ''}`, auth: true });
    }
}
//# sourceMappingURL=setup-readiness.js.map